const infoBlock = document.querySelector(".article-content__info");
const sidebar = document.querySelector(".fixed__sidebar");
const headertop = document.querySelector(".header");

if (infoBlock && sidebar) {
    const infoTop = infoBlock.getBoundingClientRect().top + window.scrollY;
    const sidebarTop = sidebar.getBoundingClientRect().top + window.scrollY;
    const headerTopHeight = header.clientHeight;

    const offset = sidebarTop - infoTop - headerTopHeight - 20;

    infoBlock.style.top = `-${offset}px`;
}